import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { getOrCreateGlobalContext, useContextWithValidation } from '@adsk/alloy-react-context';
import { useCurrentProject } from './ProjectEntitlementsContext';
/**
 * Context for current account ID.
 */
const CurrentAccountIdContext = getOrCreateGlobalContext(CONTEXT_NAMES.CurrentAccountIdContext);
const useCurrentAccountIdContext = () => useContextWithValidation(CurrentAccountIdContext, {
  hook: 'useCurrentAccountIdContext',
  provider: 'CurrentAccountIdProvider'
});
export const useCurrentAccountId = () => {
  const currentAccountIdContext = useCurrentAccountIdContext();
  return currentAccountIdContext === null || currentAccountIdContext === void 0 ? void 0 : currentAccountIdContext.accountId;
};
export const CurrentAccountIdProvider = _ref => {
  let {
    children,
    accountId: accountIdProp
  } = _ref;
  const currentProject = useCurrentProject();
  const accountIdFromProject = currentProject === null || currentProject === void 0 ? void 0 : currentProject.accountId;
  const accountId = accountIdProp || accountIdFromProject;
  const value = useMemo(() => ({
    accountId
  }), [accountId]);
  return /*#__PURE__*/React.createElement(CurrentAccountIdContext.Provider, {
    value: value
  }, children);
};
CurrentAccountIdProvider.displayName = 'CurrentAccountIdProvider';
CurrentAccountIdProvider.propTypes = {
  /** Nodes with access to context */
  children: PropTypes.node,
  /** The account ID */
  accountId: PropTypes.string
};
//# sourceMappingURL=CurrentAccountIdContext.js.map